import moment from "moment";
import { DATE_FORMAT } from "../constants";
import useGetColumnTextSearchProps from "./useGetColumnTextSearchProps";

const useColumns = () => {

    function formatMyMoney(price) {

        var currency_symbol = "₺"

        var formattedOutput = new Intl.NumberFormat('tr-TR', {
            style: 'currency',
            currency: 'TRY',
            minimumFractionDigits: 2,
        });

        return formattedOutput.format(price).replace(currency_symbol, '')
    }

    const basvuruDetailColumns = [
        {
            title: 'Id',
            dataIndex: 'objectid',
            key: 'objectid',
            defaultSortOrder: 'descend',
            sorter: (a, b) => a.objectid - b.objectid,
        },
        {
            title: 'Alt Süreç',
            dataIndex: 'altSurecAdi',
            key: 'altSurecAdi',
            sorter: (a, b) => {
                a.altSurecAdi = a.altSurecAdi || '';
                b.altSurecAdi = b.altSurecAdi || '';
                return a.altSurecAdi.localeCompare(b.altSurecAdi)
            },
        },
        {
            title: 'Aşama',
            dataIndex: 'altSurecDurumu',
            key: 'altSurecDurumu',
            sorter: (a, b) => {
                a.altSurecDurumu = a.altSurecDurumu || '';
                b.altSurecDurumu = b.altSurecDurumu || '';
                return a.altSurecDurumu.localeCompare(b.altSurecDurumu)
            },
            // ...getColumnSearchProps('altSurecDurumu'),
        },
        {
            title: 'Durumu',
            dataIndex: 'sahip',
            key: 'sahip',
            sorter: (a, b) => {
                a.sahip = a.altSurecDurumu || '';
                b.sahip = b.altSurecDurumu || '';
                return a.sahip.localeCompare(b.sahip)
            },
            // ...getColumnSearchProps('sahip'),
        },
        {
            title: 'İlk Başvuru Zamanı',
            dataIndex: 'basvuruZamani',
            key: 'basvuruZamani',
            sorter: (a, b) => moment(a.basvuruZamani).unix() - moment(b.basvuruZamani).unix(),
            // ...getColumnSearchProps('basvuruZamani'),
            render: (value) => value && <div>{moment(value).format(DATE_FORMAT)}</div>
        },
        {
            title: 'Son Başvuru Zamanı',
            dataIndex: 'basvuruZamaniSon',
            key: 'basvuruZamaniSon',
            sorter: (a, b) => moment(a.basvuruZamaniSon).unix() - moment(b.basvuruZamaniSon).unix(),
            // ...getColumnSearchProps('basvuruZamaniSon'),
            render: (value) => value && <div>{moment(value).format(DATE_FORMAT)}</div>,

        },
        {
            title: 'Başvuru Kapanış Zamanı',
            dataIndex: 'basvuruKapanisZamani',
            key: 'basvuruKapanisZamani',
            sorter: (a, b) => moment(a.basvuruKapanisZamani).unix() - moment(b.basvuruKapanisZamani).unix(),
            // ...getColumnSearchProps('basvuruKapanisZamani'),
            render: (value) => value && <div>{moment(value).format(DATE_FORMAT)}</div>,

        },
        {
            title: 'Açıklama',
            dataIndex: 'aciklama',
            key: 'aciklama',
            sorter: (a, b) => {
                a.aciklama = a.aciklama || '';
                b.aciklama = b.aciklama || '';
                return a.aciklama.localeCompare(b.aciklama)
            },
            // ...getColumnSearchProps('aciklama')
        },
        {
            title: 'Başvuran Türü',
            dataIndex: 'basvuranTuru',
            key: 'basvuranTuru',
            sorter: (a, b) => {
                a.basvuranTuru = a.basvuranTuru || '';
                b.basvuranTuru = b.basvuranTuru || '';
                return a.basvuranTuru.localeCompare(b.basvuranTuru)
            },
            // ...getColumnSearchProps('basvuranTuru')
        },
        {
            title: 'Başvuran',
            dataIndex: 'basvuran',
            key: 'basvuran',
            sorter: (a, b) => {
                a.basvuran = a.basvuran || '';
                b.basvuran = b.basvuran || '';
                return a.basvuran.localeCompare(b.basvuran)
            },
            // ...getColumnSearchProps('basvuran')
        },
        {
            title: 'Sorumlu Kişi',
            dataIndex: 'sorumlusu',
            key: 'sorumlusu',
            sorter: (a, b) => {
                a.sorumlusu = a.sorumlusu || '';
                b.sorumlusu = b.sorumlusu || '';
                return a.sorumlusu.localeCompare(b.sorumlusu)
            },
            // ...getColumnSearchProps('sorumlusu')
        },
        {
            title: 'İade Sayısı',
            dataIndex: 'iadeSayisi',
            key: 'iadeSayisi',
            sorter: (a, b) => a.iadeSayisi - b.iadeSayisi,
            // ...getColumnSearchProps('iadeSayisi')
        },
        {
            title: 'Evrak Kayıt No',
            dataIndex: 'evrakKayitNo',
            key: 'evrakKayitNo',
            sorter: (a, b) => {
                a.evrakKayitNo = a.evrakKayitNo || '';
                b.evrakKayitNo = b.evrakKayitNo || '';
                return a.evrakKayitNo.localeCompare(b.evrakKayitNo)
            },
            // ...getColumnSearchProps('evrakKayitNo')
        },
        {
            title: 'Evrak Kayıt Tarihi',
            dataIndex: 'evrakKayitTarihi',
            key: 'evrakKayitTarihi',
            sorter: (a, b) => moment(a.evrakKayitTarihi).unix() - moment(b.evrakKayitTarihi).unix(),
            // ...getColumnSearchProps('evrakKayitTarihi'),
            render: (value) => value && <div>{moment(value).format(DATE_FORMAT)}</div>
        },
        {
            title: 'Toplam Süre(gün)',
            dataIndex: 'gecenSure',
            key: 'gecenSure',
            sorter: (a, b) => a.gecenSure - b.gecenSure,
        },
        {
            title: 'Belediye Süre',
            dataIndex: 'belediyeGecenSure',
            key: 'belediyeGecenSure',
            sorter: (a, b) => a.belediyeGecenSure - b.belediyeGecenSure,
        },
        {
            title: 'Başvuran Süre',
            dataIndex: 'basvuranGecenSure',
            key: 'basvuranGecenSure',
            sorter: (a, b) => a.basvuranGecenSure - b.basvuranGecenSure,
        },
        {
            title: 'Harç Toplamı(TL)',
            dataIndex: 'harcToplami',
            key: 'harcToplami',
            sorter: (a, b) => a.harcToplami - b.harcToplami,
            render: (value) => value && <div>{formatMyMoney(value)}</div>
        }
    ]

    const basvuruColumns = [
        {
            title: 'Başvuru No',
            dataIndex: 'objectid',
            key: 'objectid',
            defaultSortOrder: 'descend',
            sorter: (a, b) => a.objectid - b.objectid,
            ...useGetColumnTextSearchProps('objectid'),
        },
        {
            title: 'Belge Türü',
            dataIndex: 'belgeTuruAdi',
            key: 'belgeTuruAdi',
            sorter: (a, b) => { return a.belgeTuruAdi.localeCompare(b.belgeTuruAdi) },
            ...useGetColumnTextSearchProps('belgeTuruAdi'),
        },
        {
            title: 'Başvuru Durumu',
            dataIndex: 'basvuruAnaDurumAdi',
            key: 'basvuruAnaDurumAdi',
            sorter: (a, b) => { return a.basvuruAnaDurumAdi.localeCompare(b.basvuruAnaDurumAdi) },
            ...useGetColumnTextSearchProps('basvuruAnaDurumAdi'),
        },
        {
            title: 'İlçe',
            dataIndex: 'ilceAdi',
            key: 'ilceAdi',
            sorter: (a, b) => { return a.ilceAdi.localeCompare(b.ilceAdi) },
            ...useGetColumnTextSearchProps('ilceAdi'),
        },
        {
            title: 'Mahalle',
            dataIndex: 'geomahalleAdi',
            key: 'geomahalleAdi',
            sorter: (a, b) => { return a.geomahalleAdi.localeCompare(b.geomahalleAdi) },
            ...useGetColumnTextSearchProps('geomahalleAdi'),
        },
        {
            title: 'Ada/Parsel',
            dataIndex: 'adaparsel',
            key: 'adaparsel',
            sorter: (a, b) => { return a.adaparsel.localeCompare(b.adaparsel) },
            ...useGetColumnTextSearchProps('adaparsel'),
        },
        {
            title: 'Parsel Alanı(m2)',
            dataIndex: 'alan',
            key: 'alan',
            sorter: (a, b) => a.alan - b.alan,
            ...useGetColumnTextSearchProps('alan'),
        },
        {
            title: 'İnşaat Alanı',
            dataIndex: 'insaatAlani',
            key: 'insaatAlani',
            sorter: (a, b) => a.insaatAlani - b.insaatAlani,
            ...useGetColumnTextSearchProps('insaatAlani'),
        },
        {
            title: 'Ruhsat Tarihi',
            dataIndex: 'ruhsatTarih',
            key: 'ruhsatTarih',
            visible: false,
            sorter: (a, b) => moment(a.ruhsatTarih).unix() - moment(b.ruhsatTarih).unix(),
            ...useGetColumnTextSearchProps('ruhsatTarih'),
            render: (value) => value && <div>{moment(value).format(DATE_FORMAT)}</div>
        },
        {
            title: 'Ruhsat Sayısı',
            dataIndex: 'ruhsatSayi',
            key: 'ruhsatSayi',
            sorter: (a, b) => {
                a.ruhsatSayi = a.ruhsatSayi || '';
                b.ruhsatSayi = b.ruhsatSayi || '';
                return a.ruhsatSayi.localeCompare(b.ruhsatSayi)
            },
            ...useGetColumnTextSearchProps('ruhsatSayi'),
        },
        {
            title: 'Başvuru Zamanı',
            dataIndex: 'belgeBasvuruZamani',
            key: 'belgeBasvuruZamani',
            sorter: (a, b) => moment(a.belgeBasvuruZamani).unix() - moment(b.belgeBasvuruZamani).unix(),
            ...useGetColumnTextSearchProps('belgeBasvuruZamani'),
            render: (value) => value && <div>{moment(value).format(DATE_FORMAT)}</div>
        },
        {
            title: 'Başvuru Kapanış Zamanı',
            dataIndex: 'belgeKapanisZamani',
            key: 'belgeKapanisZamani',
            sorter: (a, b) => moment(a.belgeKapanisZamani).unix() - moment(b.belgeKapanisZamani).unix(),
            ...useGetColumnTextSearchProps('belgeKapanisZamani'),
            render: (value) => value && <div>{moment(value).format(DATE_FORMAT)}</div>
        },
        {
            title: 'Toplam Süre(gün)',
            dataIndex: 'belgedeGecenSure',
            key: 'belgedeGecenSure',
            sorter: (a, b) => a.belgedeGecenSure - b.belgedeGecenSure,
            ...useGetColumnTextSearchProps('belgedeGecenSure'),
        },
        {
            title: 'Harç Toplamı(TL)',
            dataIndex: 'harcToplami',
            ...useGetColumnTextSearchProps('harcToplami'),
            sorter: (a, b) => a.harcToplami - b.harcToplami,
            key: 'harcToplami',
            render: (value) => value && <div>{formatMyMoney(value)}</div>
        }
    ];

    const resmiBasvuruColumns = [
        {
            title: 'Başvuru No',
            dataIndex: 'objectid',
            key: 'objectid',
            width: 100,
            defaultSortOrder: 'descend',
            sorter: (a, b) => a.objectid - b.objectid,
            ...useGetColumnTextSearchProps('objectid'),
        },
        {
            title: 'Belge Türü',
            dataIndex: 'belgeTuruAdi',
            key: 'belgeTuruAdi',
            width: 100,
            sorter: (a, b) => { return a.belgeTuruAdi.localeCompare(b.belgeTuruAdi) },
            ...useGetColumnTextSearchProps('belgeTuruAdi'),
        },
        {
            title: 'Başvuru Durumu',
            dataIndex: 'belgeBasvuruDurumu',
            key: 'belgeBasvuruDurumu',
            width: 110,
            sorter: (a, b) => { return a.belgeBasvuruDurumu.localeCompare(b.belgeBasvuruDurumu) },
            ...useGetColumnTextSearchProps('belgeBasvuruDurumu'),
        },
        {
            title: 'Başvuru Aşaması',
            dataIndex: 'altSurecDurumu',
            key: 'altSurecDurumu',
            width: 160,
            sorter: (a, b) => { return a.altSurecDurumu.localeCompare(b.altSurecDurumu) },
            ...useGetColumnTextSearchProps('altSurecDurumu'),
        },
        {
            title: 'Belge Turu',
            dataIndex: 'belgeTuruAdi',
            key: 'belgeTuruAdi',
            width: 100,
            sorter: (a, b) => { return a.belgeTuruAdi.localeCompare(b.belgeTuruAdi) },
            ...useGetColumnTextSearchProps('belgeTuruAdi'),
        },
        {
            title: 'Mahalle',
            dataIndex: 'geomahalleAdi',
            key: 'geomahalleAdi',
            width: 100,
            sorter: (a, b) => { return a.geomahalleAdi.localeCompare(b.geomahalleAdi) },
            ...useGetColumnTextSearchProps('geomahalleAdi'),
        },
        {
            title: 'Ada/Parsel',
            dataIndex: 'adaparsel',
            key: 'adaparsel',
            width: 100,
            sorter: (a, b) => { return a.adaparsel.localeCompare(b.adaparsel) },
            ...useGetColumnTextSearchProps('adaparsel'),
            responsive: ["sm"]

        },
        {
            title: 'Parsel Alanı(m2)',
            dataIndex: 'alan',
            key: 'alan',
            width: 100,
            sorter: (a, b) => a.alan - b.alan,
            ...useGetColumnTextSearchProps('alan'),
        },
        {
            title: 'İnşaat Alanı',
            dataIndex: 'insaatAlani',
            key: 'insaatAlani',
            width: 100,
            sorter: (a, b) => a.insaatAlani - b.insaatAlani,
            ...useGetColumnTextSearchProps('insaatAlani'),
        },
        {
            title: 'Bülton No',
            dataIndex: 'bultonNo',
            key: 'bultonNo',
            width: 100,
            sorter: (a, b) => {
                a.bultonNo = a.bultonNo || '';
                b.bultonNo = b.bultonNo || '';
                return a.bultonNo.localeCompare(b.bultonNo)
            },
            ...useGetColumnTextSearchProps('bultonNo'),
        },
        {
            title: 'İade Sayısı',
            dataIndex: 'iadeSayisi',
            key: 'iadeSayisi',
            width: 100,
            sorter: (a, b) => a.iadeSayisi - b.iadeSayisi,
            ...useGetColumnTextSearchProps('iadeSayisi')
        },
        {
            title: 'Açıklama',
            dataIndex: 'aciklama',
            key: 'aciklama',
            width: 105,
            sorter: (a, b) => {
                a.aciklama = a.aciklama || '';
                b.aciklama = b.aciklama || '';
                return a.aciklama.localeCompare(b.aciklama)
            },
            ...useGetColumnTextSearchProps('aciklama')
        },
        {
            title: 'Başvuran Türü',
            dataIndex: 'basvuranTuru',
            key: 'basvuranTuru',
            width: 105,
            sorter: (a, b) => {
                a.basvuranTuru = a.basvuranTuru || '';
                b.basvuranTuru = b.basvuranTuru || '';
                return a.basvuranTuru.localeCompare(b.basvuranTuru)
            },
            ...useGetColumnTextSearchProps('basvuranTuru')
        },
        {
            title: 'Başvuran',
            dataIndex: 'basvuran',
            key: 'basvuran',
            width: 105,
            sorter: (a, b) => {
                a.basvuran = a.basvuran || '';
                b.basvuran = b.basvuran || '';
                return a.basvuran.localeCompare(b.basvuran)
            },
            ...useGetColumnTextSearchProps('basvuran')
        },
        {
            title: 'Sorumlu Kişi',
            dataIndex: 'sorumlusu',
            key: 'sorumlusu',
            width: 100,
            sorter: (a, b) => {
                a.sorumlusu = a.sorumlusu || '';
                b.sorumlusu = b.sorumlusu || '';
                return a.sorumlusu.localeCompare(b.sorumlusu)
            },
            ...useGetColumnTextSearchProps('sorumlusu')
        },
        {
            title: 'Evrak Kayıt No',
            dataIndex: 'evrakKayitNo',
            key: 'evrakKayitNo',
            width: 100,
            sorter: (a, b) => {
                a.evrakKayitNo = a.evrakKayitNo || '';
                b.evrakKayitNo = b.evrakKayitNo || '';
                return a.evrakKayitNo.localeCompare(b.evrakKayitNo)
            },
            ...useGetColumnTextSearchProps('evrakKayitNo')
        },
        {
            title: 'Evrak Kayıt Tarihi',
            dataIndex: 'evrakKayitTarihi',
            key: 'evrakKayitTarihi',
            width: 105,
            sorter: (a, b) => moment(a.evrakKayitTarihi).unix() - moment(b.evrakKayitTarihi).unix(),
            ...useGetColumnTextSearchProps('evrakKayitTarihi'),
            render: (value) => value && <div>{moment(value).format(DATE_FORMAT)}</div>
        },
        {
            title: 'Başvuru Zamanı',
            dataIndex: 'basvuruZamani',
            key: 'basvuruZamani',
            width: 105,
            sorter: (a, b) => moment(a.basvuruZamani).unix() - moment(b.basvuruZamani).unix(),
            ...useGetColumnTextSearchProps('basvuruZamani'),
            render: (value) => value && <div>{moment(value).format(DATE_FORMAT)}</div>
        },
        {
            title: 'Başvuru Kapanış Zamanı',
            dataIndex: 'basvuruKapanisZamani',
            key: 'basvuruKapanisZamani',
            width: 105,
            sorter: (a, b) => moment(a.basvuruKapanisZamani).unix() - moment(b.basvuruKapanisZamani).unix(),
            ...useGetColumnTextSearchProps('basvuruKapanisZamani'),
            render: (value) => value && <div>{moment(value).format(DATE_FORMAT)}</div>
        },
        {
            title: 'Toplam Süre(gün)',
            dataIndex: 'gecenSure',
            key: 'gecenSure',
            width: 100,
            sorter: (a, b) => a.gecenSure - b.gecenSure,
            ...useGetColumnTextSearchProps('gecenSure'),
        },
        {
            title: 'Belediye Süre',
            dataIndex: 'belediyeGecenSure',
            key: 'belediyeGecenSure',
            width: 100,
            sorter: (a, b) => a.belediyeGecenSure - b.belediyeGecenSure,
        },
        {
            title: 'Başvuran Süre',
            dataIndex: 'basvuranGecenSure',
            key: 'basvuranGecenSure',
            width: 100,
            sorter: (a, b) => a.basvuranGecenSure - b.basvuranGecenSure,
        },
        {
            title: 'Harç Toplamı(TL)',
            dataIndex: 'harcToplami',
            width: 100,
            ...useGetColumnTextSearchProps('harcToplami'),
            sorter: (a, b) => a.harcToplami - b.harcToplami,
            key: 'harcToplami',
            render: (value) => value && <div>{formatMyMoney(value)}</div>
        }
    ];

    const basvuruSurecGecmisColumns = [
        {
            title: 'Durum Adı',
            dataIndex: 'stateDesc',
            key: 'stateDesc',
            sorter: (a, b) => { return a.stateDesc.localeCompare(b.stateDesc) },
            ...useGetColumnTextSearchProps('stateDesc'),
        },
        {
            title: 'Süre',
            dataIndex: 'gecenSure',
            key: 'gecenSure',
            sorter: (a, b) => a.gecenSure - b.gecenSure,
            ...useGetColumnTextSearchProps('gecenSure'),
        }
    ]
    const altSurecBasvuruColumns = [
        {
            title: 'Başvuru No',
            dataIndex: 'objectid',
            key: 'objectid',
            width: 100,
            defaultSortOrder: 'descend',
            sorter: (a, b) => a.objectid - b.objectid,
            ...useGetColumnTextSearchProps('objectid'),
        },
        {
            title: 'Belge Türü',
            dataIndex: 'altSurecAdi',
            key: 'altSurecAdi',
            width: 100,
            sorter: (a, b) => { return a.altSurecAdi.localeCompare(b.altSurecAdi) },
            ...useGetColumnTextSearchProps('altSurecAdi'),
        },
        {
            title: 'Başvuru Durumu',
            dataIndex: 'belgeBasvuruDurumu',
            key: 'belgeBasvuruDurumu',
            width: 110,
            sorter: (a, b) => { return a.belgeBasvuruDurumu.localeCompare(b.belgeBasvuruDurumu) },
            ...useGetColumnTextSearchProps('belgeBasvuruDurumu'),
        },
        {
            title: 'Başvuru Aşaması',
            dataIndex: 'altSurecDurumu',
            key: 'altSurecDurumu',
            width: 160,
            sorter: (a, b) => { return a.altSurecDurumu.localeCompare(b.altSurecDurumu) },
            ...useGetColumnTextSearchProps('altSurecDurumu'),
        },
        {
            title: 'Mahalle',
            dataIndex: 'geomahalleAdi',
            key: 'geomahalleAdi',
            width: 100,
            sorter: (a, b) => { return a.geomahalleAdi.localeCompare(b.geomahalleAdi) },
            ...useGetColumnTextSearchProps('geomahalleAdi'),
        },
        {
            title: 'Ada/Parsel',
            dataIndex: 'adaparsel',
            key: 'adaparsel',
            width: 100,
            sorter: (a, b) => { return a.adaparsel.localeCompare(b.adaparsel) },
            ...useGetColumnTextSearchProps('adaparsel'),
            responsive: ["sm"]

        },
        {
            title: 'Parsel Alanı(m2)',
            dataIndex: 'alan',
            key: 'alan',
            width: 100,
            sorter: (a, b) => a.alan - b.alan,
            ...useGetColumnTextSearchProps('alan'),
        },
        {
            title: 'İnşaat Alanı',
            dataIndex: 'insaatAlani',
            key: 'insaatAlani',
            width: 100,
            sorter: (a, b) => a.insaatAlani - b.insaatAlani,
            ...useGetColumnTextSearchProps('insaatAlani'),
        },
        {
            title: 'Bülton No',
            dataIndex: 'bultonNo',
            key: 'bultonNo',
            width: 100,
            sorter: (a, b) => {
                a.bultonNo = a.bultonNo || '';
                b.bultonNo = b.bultonNo || '';
                return a.bultonNo.localeCompare(b.bultonNo)
            },
            ...useGetColumnTextSearchProps('bultonNo'),
        },
        {
            title: 'İade Sayısı',
            dataIndex: 'iadeSayisi',
            key: 'iadeSayisi',
            width: 100,
            sorter: (a, b) => a.iadeSayisi - b.iadeSayisi,
            ...useGetColumnTextSearchProps('iadeSayisi')
        },
        {
            title: 'Açıklama',
            dataIndex: 'aciklama',
            key: 'aciklama',
            width: 105,
            sorter: (a, b) => {
                a.aciklama = a.aciklama || '';
                b.aciklama = b.aciklama || '';
                return a.aciklama.localeCompare(b.aciklama)
            },
            ...useGetColumnTextSearchProps('aciklama')
        },
        {
            title: 'Başvuran Türü',
            dataIndex: 'basvuranTuru',
            key: 'basvuranTuru',
            width: 105,
            sorter: (a, b) => {
                a.basvuranTuru = a.basvuranTuru || '';
                b.basvuranTuru = b.basvuranTuru || '';
                return a.basvuranTuru.localeCompare(b.basvuranTuru)
            },
            ...useGetColumnTextSearchProps('basvuranTuru')
        },
        {
            title: 'Başvuran',
            dataIndex: 'basvuran',
            key: 'basvuran',
            width: 105,
            sorter: (a, b) => {
                a.basvuran = a.basvuran || '';
                b.basvuran = b.basvuran || '';
                return a.basvuran.localeCompare(b.basvuran)
            },
            ...useGetColumnTextSearchProps('basvuran')
        },
        {
            title: 'Sorumlu Kişi',
            dataIndex: 'sorumlusu',
            key: 'sorumlusu',
            width: 100,
            sorter: (a, b) => {
                a.sorumlusu = a.sorumlusu || '';
                b.sorumlusu = b.sorumlusu || '';
                return a.sorumlusu.localeCompare(b.sorumlusu)
            },
            ...useGetColumnTextSearchProps('sorumlusu')
        },
        {
            title: 'Evrak Kayıt No',
            dataIndex: 'evrakKayitNo',
            key: 'evrakKayitNo',
            width: 100,
            sorter: (a, b) => {
                a.evrakKayitNo = a.evrakKayitNo || '';
                b.evrakKayitNo = b.evrakKayitNo || '';
                return a.evrakKayitNo.localeCompare(b.evrakKayitNo)
            },
            ...useGetColumnTextSearchProps('evrakKayitNo')
        },
        {
            title: 'Evrak Kayıt Tarihi',
            dataIndex: 'evrakKayitTarihi',
            key: 'evrakKayitTarihi',
            width: 105,
            sorter: (a, b) => moment(a.evrakKayitTarihi).unix() - moment(b.evrakKayitTarihi).unix(),
            ...useGetColumnTextSearchProps('evrakKayitTarihi'),
            render: (value) => value && <div>{moment(value).format(DATE_FORMAT)}</div>
        },
        {
            title: 'Başvuru Zamanı',
            dataIndex: 'basvuruZamani',
            key: 'basvuruZamani',
            width: 105,
            sorter: (a, b) => moment(a.basvuruZamani).unix() - moment(b.basvuruZamani).unix(),
            ...useGetColumnTextSearchProps('basvuruZamani'),
            render: (value) => value && <div>{moment(value).format(DATE_FORMAT)}</div>
        },
        {
            title: 'Başvuru Kapanış Zamanı',
            dataIndex: 'basvuruKapanisZamani',
            key: 'basvuruKapanisZamani',
            width: 105,
            sorter: (a, b) => moment(a.basvuruKapanisZamani).unix() - moment(b.basvuruKapanisZamani).unix(),
            ...useGetColumnTextSearchProps('basvuruKapanisZamani'),
            render: (value) => value && <div>{moment(value).format(DATE_FORMAT)}</div>
        },
        {
            title: 'Toplam Süre(gün)',
            dataIndex: 'gecenSure',
            key: 'gecenSure',
            width: 100,
            sorter: (a, b) => a.gecenSure - b.gecenSure,
            ...useGetColumnTextSearchProps('gecenSure'),
        },
        {
            title: 'Belediye Süre',
            dataIndex: 'belediyeGecenSure',
            key: 'belediyeGecenSure',
            width: 100,
            sorter: (a, b) => a.belediyeGecenSure - b.belediyeGecenSure,
        },
        {
            title: 'Başvuran Süre',
            dataIndex: 'basvuranGecenSure',
            key: 'basvuranGecenSure',
            width: 100,
            sorter: (a, b) => a.basvuranGecenSure - b.basvuranGecenSure,
        },
        {
            title: 'Harç Toplamı(TL)',
            dataIndex: 'harcToplami',
            width: 100,
            ...useGetColumnTextSearchProps('harcToplami'),
            sorter: (a, b) => a.harcToplami - b.harcToplami,
            key: 'harcToplami',
            render: (value) => value && <div>{formatMyMoney(value)}</div>
        }
    ];
    return { basvuruDetailColumns, basvuruColumns, basvuruSurecGecmisColumns, resmiBasvuruColumns, altSurecBasvuruColumns };
}

export default useColumns;